import React from 'react';

const Background: React.FC = () => {
  return (
    <div className="main_bg" style={{zIndex: 0, position: "absolute"}}>
      <img
        src="/documents/d/guest/rectangle-3771-1"
        loading="lazy"
        sizes="100vw"
        srcSet="/documents/d/guest/rectangle-3771-p-500-1 500w, /documents/d/guest/rectangle-3771-p-800-1 800w, /documents/d/guest/rectangle-3771-p-1080-1 1080w, /documents/d/guest/rectangle-3771 1440w"
        alt=""
        className="main_bg-img-desp"
      />
      <img
        src="/documents/d/guest/imagenss-1"
        loading="lazy"
        alt=""
        className="main_bg-img-movil"
      />
      <img
        src="/documents/d/guest/group-40782-1"
        loading="lazy"
        sizes="100vw"
        srcSet="/documents/d/guest/group-40782-p-500-1 500w, /documents/d/guest/group-40782-p-800-1 800w, /documents/d/guest/group-40782_1 891w"
        alt=""
        className="main_bg-person is-home"
      />
    </div>
  );
};

export default Background;